import Accordion from "components/common/accordion/Accordion";
import FruitDatalist from "components/entities/agriculture/fruit/FruitDatalist";
import AgricultureMaintenanceLogTypeList from "components/entities/agriculture/work/maintenances/types/AgricultureMaintenanceLogTypeList";
import SaleTemplateDatalist from "components/entities/templates/agriculture/sale/SaleTemplateDatalist";
import HarvestTemplateDatalist from "components/entities/templates/agriculture/work/HarvestTemplateDatalist";
import { Roles } from "utilities/app-utilities";
import useAppContext from "utilities/hooks/useAppContext";

const AgricultureOtherPage = () => {
    const context = useAppContext();
    return (
        <div className="md:px-6">
            <Accordion
                name="fruit"
                title="pages.agriculture.fruit.list"
                hidden={!context.userHasRole(Roles.AGRICULTURE_SALES_READ)}
            >
                <FruitDatalist />
            </Accordion>
            <Accordion
                name="maintenanceTypes"
                title="pages.agriculture.work.maintenance.type.list"
                hidden={!context.userHasRole(Roles.AGRICULTURE_WORK_WRITE)}
            >
                <AgricultureMaintenanceLogTypeList name="agriculture-other" />
            </Accordion>
            <Accordion // templates
                name="templates"
                title="common.templates"
                hidden={!context.userContainsRoles([Roles.AGRICULTURE_SALES_WRITE, Roles.AGRICULTURE_WORK_WRITE])}
            >
                <Accordion
                    open
                    name="fruit"
                    title="pages.template.work.harvest.list"
                    hidden={!context.userHasRole(Roles.AGRICULTURE_WORK_WRITE)}
                >
                    <HarvestTemplateDatalist />
                </Accordion>
                <Accordion
                    open
                    name="fruit"
                    title="pages.template.sale.list"
                    hidden={!context.userHasRole(Roles.AGRICULTURE_SALES_WRITE)}
                >
                    <SaleTemplateDatalist />
                </Accordion>
            </Accordion>
        </div>
    );
};

export default AgricultureOtherPage;
